import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from 'react-router';
import AuthContext from "../context/AuthContext";
import './Header.css';

const Header = () => {

    const { auth, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef(null);


    const handleLogout = () => {
        logout();
        setIsMenuOpen(false);
        navigate('/login');
    };

    const handleNavigate = (path) => {
        setIsMenuOpen(false);
        navigate(path);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const isActive = (path) => location.pathname === path ? 'active-link' : '';

    return (
        <header className="header">
            <div className="logo">
                <Link to="/">Travel Planer</Link>
            </div>

            <nav className="main-navigation">
                <Link to="/" className={`nav-item ${isActive('/')}`}>
                    Main Page
                </Link>
                <Link to="/creator" className={`nav-item ${isActive('/creator')}`}>
                    Creator
                </Link>
                {auth.token && (
                    <Link to="/my_plans" className={`nav-item $isActive('my_plans')`}>
                        My Plans
                    </Link>
                )}
            </nav>

            <div className="user-action">

                {auth.token ? (
                    <div className="logged-in-container">
                        <div className="points-display">
                            <span className="points-icon">🪙</span>
                            <span className="points-value">
                                {auth.user?.points !== undefined ? auth.user.points : '...'}
                            </span>
                            <button
                                className="add-points-btn"
                                onClick={() => alert('Work in Progress...')}
                                title="Add Points"
                            >
                                +
                            </button>
                        </div>

                        <div className="user-menu-container" ref={menuRef}>
                            <div
                                className="user-avatar"
                                onClick={() => setIsMenuOpen(!isMenuOpen)}
                                title="auth.user?.name"
                            >
                                {auth.user?.name ? auth.user.name.charAt(0).toUpperCase() : "U"}
                            </div>

                            {isMenuOpen && (
                                <div className="dropdown-menu">
                                    <div className="menu-header">
                                        Hi, <strong>{auth.user?.name}</strong>
                                    </div>
                                    <div className="menu-divider"></div>

                                    <button
                                        className="menu-item"
                                        onClick={() => handleNavigate('/profile')}
                                    >
                                       Profile 
                                    </button>

                                    <button
                                        className="menu-item"
                                        onClick={() => handleNavigate('/my_plans')}
                                    >
                                       My Plans 
                                    </button>

                                    <button
                                        className="menu-item logout-item"
                                        onClick={handleLogout}
                                    >
                                        Logout
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                ) : (
                    <div className="auth-links">
                        <Link to="/login" className="nav-link">Login</Link>
                        <Link to="/register" className="nav-link register-btn">Register</Link>
                    </div>
                )}
            </div>
        </header>
    )



};

export default Header;
